"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteGalleryModal = DeleteGalleryModal;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const elements_1 = require("@src/components/elements");
const icons_1 = require("@ant-design/icons");
const react_intl_1 = require("react-intl");
const StyledDeleteOutlined = (0, styled_components_1.default)(icons_1.DeleteOutlined) `
	color: red;
	font-size: 2rem;
	margin-bottom: 1rem;
`;
function DeleteGalleryModal({ isOpen, onOk, onCancel }) {
    return ((0, jsx_runtime_1.jsx)(elements_1.Modal, { visible: isOpen, onOk: onOk, onCancel: onCancel, footer: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(elements_1.Button, { onClick: onCancel, size: "middle", type: "ghost", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.cancel" }) }), (0, jsx_runtime_1.jsx)(elements_1.Button, { onClick: onOk, danger: true, size: "middle", type: "primary", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.delete" }) })] }), children: (0, jsx_runtime_1.jsxs)("div", { className: "m-m flex-center flex-col font-size-m", children: [(0, jsx_runtime_1.jsx)(StyledDeleteOutlined, {}), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.offer.assets.delete_gallery_confirm" })] }) }));
}
